import { formatCurrencyConverter } from "./formatCurrencyConverter";

interface Prize {
    type?: 'percent' | 'money';
    amount?: number;
    percent?: number;
    currency?: string;
    description?: string;
}

interface RaceData {
    place_from: number;
    place_to: number;
    prize?: Prize;
}

interface TransformedData {
    place: number | string;
    type: string | undefined;
    prize: string | undefined;
    currency: string | undefined;
}

export const transformRacePrizePool = (data: RaceData[], prize: number): TransformedData[] | null => {
    if (!data || !prize) {
        return null;
    } else {
        const newData: TransformedData[] = [];

        data.sort((r1, r2) => r1.place_from - r2.place_from)?.forEach((item) => {
            newData.push({
                place: item.place_from === item.place_to ? item.place_from : `${item.place_from}-${item.place_to}`,
                type: item.prize?.type === 'percent' ? `${item.prize?.percent}%` : item.prize?.type,
                prize: item?.prize?.type === 'money' ? formatCurrencyConverter(
                    item?.prize?.type === 'money' ?
                        item?.prize?.amount :
                        (item.prize?.percent! * prize / 100) * (item.place_to - item.place_from >= 1 ? item.place_to + 1 - item.place_from : 1),
                    item?.prize?.currency
                ) : item?.prize?.description,
                currency: item?.prize?.currency
            });
        });

        return newData;
    }
}

export const isBetweenOrEqual = (num: number, from: number, to: number): boolean => num >= from && num <= to;
